import React from 'react';
import { CRow, CCol, CButton } from '@coreui/react-pro';
import { CXTextInput, CXDropDown, CXButton } from '../../../components/CXForm';

export type Option = { text: string; value: string };

type Props = {
    // search
    searchUFI: string;
    setSearchUFI: (v: string) => void;
    searchComment: string;
    setSearchComment: (v: string) => void;

    // filters + options
    origin: string;
    setOrigin: (v: string) => void;
    originOptions: Option[];

    dest: string;
    setDest: (v: string) => void;
    destOptions: Option[];

    category: string;
    setCategory: (v: string) => void;
    categoryOptions: Option[];

    subject: string;
    setSubject: (v: string) => void;
    subjectOptions: Option[];

    creator: string;
    setCreator: (v: string) => void;
    creatorOptions: Option[];

    assigneeLead: string;
    setAssigneeLead: (v: string) => void;
    assigneeLeadOptions: Option[];

    assigneeGroup: string;
    setAssigneeGroup: (v: string) => void;
    assigneeGroupOptions: Option[];

    status: string;
    setStatus: (v: string) => void;
    statusOptions: Option[];

    // actions
    onSearch: () => void;
    onClearFilters: () => void;
    showClearFilters: boolean;

    // utility: convert "ALL" special value to an empty string (clears the filter)
    asAllOrValue: (v: string) => string;

    // UI
    dropdownWidth?: number;          // default 200
};

export default function FiltersBar({
    searchUFI, setSearchUFI,
    searchComment, setSearchComment,

    origin, setOrigin, originOptions,
    dest, setDest, destOptions,
    category, setCategory, categoryOptions,
    subject, setSubject, subjectOptions,
    creator, setCreator, creatorOptions,
    assigneeLead, setAssigneeLead, assigneeLeadOptions,
    assigneeGroup, setAssigneeGroup, assigneeGroupOptions,
    status, setStatus, statusOptions,

    onSearch,
    onClearFilters,
    showClearFilters,
    asAllOrValue,

    dropdownWidth = 200
}: Props) {

    const inputStyle: React.CSSProperties = { width: 230 };

    return (
        <>
            {/* Search section */}
            <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap', marginBottom: 20 }}>
                <div style={inputStyle}>
                    <CXTextInput
                        placeholder="Search by UFI"
                        value={searchUFI}
                        onChange={setSearchUFI}
                        className={searchUFI?.trim() ? 'has-value' : ''}
                    />
                </div>
                <div style={inputStyle}>
                    <CXTextInput
                        placeholder="Search by comment"
                        value={searchComment}
                        onChange={setSearchComment}
                        className={searchComment?.trim() ? 'has-value' : ''}
                    />
                </div>
                <div>
                    <CXButton text="Search" onClick={onSearch} fontSize="16px" width="200%" />
                </div>

            </div>

            {/* Dropdown filter row (selection applies immediately; ALL = clear filter) */}
            <CRow className="g-3 align-items-center" style={{ marginBottom: 8 }}>
                <CCol xs="auto">
                    <div style={{ width: dropdownWidth }}>
                        <CXDropDown
                            zIndex={1030}
                            value={origin}
                            placeholder="Origin"
                            onChange={(v: string) => setOrigin(asAllOrValue(v))}
                            options={originOptions}
                        />
                    </div>
                </CCol>

                <CCol xs="auto">
                    <div style={{ width: dropdownWidth }}>
                        <CXDropDown
                            zIndex={1030}
                            value={dest}
                            placeholder="Dest."
                            onChange={(v: string) => setDest(asAllOrValue(v))}
                            options={destOptions}
                        />
                    </div>
                </CCol>

                <CCol xs="auto">
                    <div style={{ width: dropdownWidth }}>
                        <CXDropDown
                            zIndex={1029}
                            value={category}
                            placeholder="Category"
                            onChange={(v: string) => setCategory(asAllOrValue(v))}
                            options={categoryOptions}
                        />
                    </div>
                </CCol>

                <CCol xs="auto">
                    <div style={{ width: dropdownWidth }}>
                        <CXDropDown
                            zIndex={1029}
                            value={subject}
                            placeholder="Subject"
                            onChange={(v: string) => setSubject(asAllOrValue(v))}
                            options={subjectOptions}
                        />
                    </div>
                </CCol>

                <CCol xs="auto">
                    <div style={{ width: dropdownWidth }}>
                        <CXDropDown
                            zIndex={1029}
                            value={creator}
                            placeholder="Creator"
                            onChange={(v: string) => setCreator(asAllOrValue(v))}
                            options={creatorOptions}
                        />
                    </div>
                </CCol>

                <CCol xs="auto">
                    <div style={{ width: dropdownWidth }}>
                        <CXDropDown
                            zIndex={1028}
                            value={assigneeLead}
                            placeholder="Assignee lead"
                            onChange={(v: string) => setAssigneeLead(asAllOrValue(v))}
                            options={assigneeLeadOptions}
                        />
                    </div>
                </CCol>

                <CCol xs="auto">
                    <div style={{ width: dropdownWidth }}>
                        <CXDropDown
                            zIndex={1028}
                            value={assigneeGroup}
                            placeholder="Assignee group"
                            onChange={(v: string) => setAssigneeGroup(asAllOrValue(v))}
                            options={assigneeGroupOptions}
                        />
                    </div>
                </CCol>

                <CCol xs="auto">
                    <div style={{ width: dropdownWidth }}>
                        <CXDropDown
                            zIndex={1028}
                            value={status}
                            placeholder="Status"
                            onChange={(v: string) => setStatus(asAllOrValue(v))}
                            options={statusOptions}
                        />
                    </div>
                </CCol>

                <CCol xs="auto" className="d-flex align-items-center">
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ width: 130, minHeight: 38 }}
                    >
                        <CButton
                            color="link"
                            style={{
                                padding: '0px',
                                visibility: showClearFilters ? 'visible' : 'hidden',
                            }}
                            className={'linkButton clickable'}
                            onClick={onClearFilters}
                        >
                            Clear all filters
                        </CButton>
                    </div>
                </CCol>
            </CRow>
        </>
    );
}
